import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=c855a8ec&scoped=true&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c855a8ec",
  null
  
)

export default component.exports